import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b5ef23d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7b5ef23d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ef23d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5ef23d')) {
      api.createRecord('7b5ef23d', component.options)
    } else {
      api.reload('7b5ef23d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b5ef23d&scoped=true", function () {
      api.rerender('7b5ef23d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Weforsys-table-draggs/index.vue"
export default component.exports